import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'e5core-ui-monitor-sla-team-productivity',
  template: `
    <e5core-ui-monitor-sla-team-productivity-highcharts>
    </e5core-ui-monitor-sla-team-productivity-highcharts>
  `
})
export class E5coreUiMonitorSlaTeamProductivityComponent implements OnInit {

  constructor() { }

  ngOnInit() {

  }


}
